import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import PT from 'prop-types';
import { i as isHorizontalFlipOnRTL } from '../utils/isHorizontalFlipOnRTL-7yAAaYS8.js';
import { u as useGetIcon } from '../utils/useGetIcon-De52vkFi.js';
import { g as getIconSize } from '../utils/getIconSize-Cao9i0V7.js';
import { r as renderIconSVG } from '../utils/renderIconSVG-B_mwkbnq.js';
import { I as IconClassWrapper } from '../Icon.styles-vvzjr50m.js';
import { E as ErrorBoundary } from './ErrorBoundary-Cg9U0Emd.js';

const farIcons = new Set(['lightbulb', 'calendar-alt', 'clock', 'text-separator', 'trash-alt', 'house']);
const IconWrapperStyled = /*#__PURE__*/styled('i').withConfig({
  componentId: "sc-storm-ui-30063520__sc-1vzu9xb-0"
})(["", " ", ""], ({
  $blockSize
}) => $blockSize ? css(["display:inline-block;> .svg-inline--fa{display:block;}"]) : '',
// Only use the icon RTL flipper when using a logical direction icon type;
({
  $horizontalFlipOnRTL
}) => $horizontalFlipOnRTL ? css(["/*! @noflip */ [dir=\"rtl\"] && > svg{/*! @noflip */ transform:scaleX(-1);}"]) : '');
const RemoteIcon = ({
  type,
  size,
  transform,
  blockSize = false,
  'data-testid': dataTestId,
  ...rest
}) => {
  const prefix = farIcons.has(type) ? 'far' : 'fas';
  const [iconName, horizontalFlipOnRTL] = isHorizontalFlipOnRTL(type);
  const icon = useGetIcon(prefix, iconName);
  const iconFontSize = getIconSize(size);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(IconClassWrapper, {
    $pulse: iconName === 'spinner',
    $size: size,
    $fontSize: iconFontSize
  }, className => /*#__PURE__*/React__default.createElement(IconWrapperStyled, _extends({}, rest, {
    $fontSize: iconFontSize,
    $blockSize: blockSize,
    $horizontalFlipOnRTL: horizontalFlipOnRTL,
    dangerouslySetInnerHTML: {
      __html: renderIconSVG(icon, transform, className)
    },
    "data-testid": dataTestId || `storm-ui-icon-${iconName}`
  }))));
};
RemoteIcon.propTypes = {
  /**
   * The type of Icon.
   */
  type: PT.string.isRequired,
  /**
   * Font Awesome [sizing classes ](https://fontawesome.com/v5.0.13/how-to-use/on-the-web/styling/sizing-icons).
   */
  size: PT.oneOf(['xs', 'sm', 'lg', '2x', '3x', '5x', '7x', '10x']),
  /**
   * Font Awesome [transform element attribute ](https://fontawesome.com/v5.0.13/how-to-use/on-the-web/styling/power-transforms).
   */
  transform: PT.string,
  /**
   * Changes the `<svg/>` to be `display: block;`.
   * Use when centering icons in small spaces.
   */
  blockSize: PT.bool
};
RemoteIcon.defaultProps = {
  size: undefined,
  transform: undefined,
  blockSize: false,
  'data-testid': undefined
};

export { RemoteIcon as R };
//# sourceMappingURL=RemoteIcon-DKExdFRy.js.map
